export const konamiPattern = (x, y, t, density) => {
  const cx = 30;
  const cy = 17.5;
  const dx = x - cx;
  const dy = y - cy;
  const angle = Math.atan2(dy, dx);
  const dist = Math.sqrt(dx * dx + dy * dy);
  
  // Chaotic rainbow spiral
  const spiral = Math.sin(angle * 5 + dist * 0.3 - t * 4) * Math.cos(dist * 0.2 + t * 3);
  const pulse = Math.sin(t * 5) * Math.exp(-dist * 0.1);
  const chaos = Math.sin(x * 0.5 + t * 2) * Math.cos(y * 0.5 - t * 2);
  const rings = Math.sin(dist * 0.4 - t * 6) * 0.3;
  
  return (spiral * 0.4 + pulse * 0.3 + chaos * 0.2 + rings * 0.1) * density;
};

export const patterns = {
  think: (x, y, t, density) => {
    const cx = 30;
    const cy = 17.5;
    const dx = x - cx;
    const dy = y - cy;
    const dist = Math.sqrt(dx * dx + dy * dy);
    
    const clusters = Math.sin(dx * 0.4 + t * 0.3) * Math.cos(dy * 0.4 - t * 0.2);
    const scatter = Math.sin(x * 0.8 + y * 0.8 + t * 0.5) * 0.3;
    const eggCore = Math.exp(-dist * 0.08) * 0.2;
    
    return (clusters * 0.6 + scatter * 0.3 + eggCore * 0.1) * density;
  },
  
  design: (x, y, t, density) => {
    const cx = 30;
    const cy = 17.5;
    const dx = x - cx;
    const dy = y - cy;
    const angle = Math.atan2(dy, dx);
    const dist = Math.sqrt(dx * dx + dy * dy);
    
    const lines = Math.sin(angle * 4 + t * 0.3) * Math.cos(dist * 0.15);
    const structure = Math.sin(x * 0.2 + t * 0.2) * Math.cos(y * 0.2);
    const eggVoid = Math.exp(-dist * 0.1) * -0.3;
    
    return (lines * 0.5 + structure * 0.4 + eggVoid * 0.1) * density;
  },
  
  develop: (x, y, t, density) => {
    const systematic = Math.sin(x * 0.3 + t * 0.2) * Math.cos(y * 0.3 - t * 0.15);
    const grid = Math.sin(x * 0.5) * Math.sin(y * 0.5) * 0.3;
    const flow = Math.sin((x + y) * 0.2 + t * 0.25) * 0.2;
    
    const cx = 30;
    const cy = 17.5;
    const dx = x - cx;
    const dy = y - cy;
    const dist = Math.sqrt(dx * dx + dy * dy);
    const eggOutline = Math.abs(Math.sin(dist * 0.2 - t * 0.1)) > 0.95 ? 0.3 : 0;
    
    return (systematic * 0.5 + grid * 0.3 + flow * 0.1 + eggOutline * 0.1) * density;
  },
  
  launch: (x, y, t, density) => {
    const cx = 30;
    const cy = 17.5;
    const dx = x - cx;
    const dy = y - cy;
    const angle = Math.atan2(dy, dx);
    const dist = Math.sqrt(dx * dx + dy * dy);
    
    const radiate = Math.sin(dist * 0.2 - t * 0.5) * Math.cos(angle * 3);
    const explosion = Math.sin(dist * 0.15 - t * 0.6) * 0.5;
    const eggBurst = dist < 8 ? Math.sin(t * 0.8) * 0.3 : 0;
    
    return (radiate * 0.5 + explosion * 0.4 + eggBurst * 0.1) * density;
  },
  
  scale: (x, y, t, density) => {
    const cx = 30;
    const cy = 17.5;
    const dx = x - cx;
    const dy = y - cy;
    const angle = Math.atan2(dy, dx);
    const dist = Math.sqrt(dx * dx + dy * dy);
    
    const waves = Math.sin(dist * 0.2 - t * 0.4) * Math.cos(dist * 0.1 + t * 0.3);
    const spiral = Math.sin(angle * 2 + dist * 0.15 - t * 0.5) * 0.4;
    const eggCycle = Math.sin(dist * 0.1 - t * 0.3) * Math.exp(-dist * 0.05) * 0.2;
    
    return (waves * 0.5 + spiral * 0.3 + eggCycle * 0.2) * density;
  }
};